import UserService from './services/userService';

export const onSignIn = (Login, Password) => {
    return UserService.auth(Login, Password);
};

export const onSignOut = () => {
    return new Promise((resolve, reject) => {
        localStorage.clear();
        resolve();
    });
};

export const isSignedIn = () => {
    let token = UserService.getToken();
    if (token !== null) {
        return true;
    }
    return false;
};



// WEBPACK FOOTER //
// ./src/Auth.js